<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  modelValue: {
    type: String,
    default: '#000000',
  },
  label: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['update:modelValue']);

const { t } = useI18n();

const colorValue = ref(props.modelValue || '#000000');

watch(
  () => props.modelValue,
  newVal => {
    colorValue.value = newVal || '#000000';
  }
);

watch(colorValue, newVal => {
  emit('update:modelValue', newVal);
});
</script>

<template>
  <div>
    <label class="block text-sm font-medium text-n-slate-12 mb-1.5">
      {{ label }}
    </label>
    <div class="flex items-center gap-3">
      <div class="relative">
        <input
          v-model="colorValue"
          type="color"
          class="w-12 h-10 rounded-lg border-2 border-n-weak cursor-pointer hover:border-n-blue-6 transition-all appearance-none"
        />
      </div>
      <input
        v-model="colorValue"
        type="text"
        :placeholder="t('WEBSITE.THEME.COLOR_PLACEHOLDER')"
        class="flex-1 px-3 py-2 text-sm border rounded-lg bg-n-solid-2 border-n-weak text-n-slate-12 focus:outline-none focus:ring-2 focus:ring-n-blue-9 focus:border-transparent transition-all font-mono uppercase"
        pattern="^#[0-9A-Fa-f]{6}$"
      />
      <div
        class="w-10 h-10 rounded-lg border-2 border-n-weak flex-shrink-0"
        :style="{ backgroundColor: colorValue }"
      />
    </div>
  </div>
</template>

<style scoped>
input[type='color']::-webkit-color-swatch-wrapper {
  padding: 0;
}

input[type='color']::-webkit-color-swatch {
  border: none;
  border-radius: 0.5rem;
}

input[type='color']::-moz-color-swatch {
  border: none;
  border-radius: 0.5rem;
}
</style>
